import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    userToken: (state) => state.userToken,
    loggedIn: (state) => state.loggedIn,
    userRole: (state) => state.userRole,
  }),
  ...mapGetters('auth', ['loggedIn','getUser', 'getToken', 'getRole']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    timezone: (state) => state.timezone,
    loader: (state) => state.loader
  })
}

export const searchComputed = {
  ...mapState('search', {
    type: (state) => state.type,
    page: (state) => state.page,
    pageSize: (state) => state.pageSize,
    order: (state) => state.order,
    searchByData: (state) => state.searchByData,
    searchByType: (state) => state.searchByType,
    ...mapGetters('search', ['getSearchType','getSearchPage', 'getSearchPageSize', 'getSearchOrder', 'getSearchByData', 'getSearchByType']),
  })
}

export const onlineComputed = {
  ...mapState('online', {
    users: (state) => state.users,
  }),
  ...mapGetters('online', ['getOnlineUsers']),
}

export const onlineMethods = mapActions('online', ['hasUserOnSamePath', 'setOnlineUsers'])

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'authAction', 'getAuthUser'])

export const searchMethods = mapActions('search', ['changeSearch', 'changePage', 'changePageSize', 'changeOrder'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLoaderValue', 'changeTimezoneValue'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
